import React from "react";
import TeamName from "./TeamName";
import { AppConfig } from "../../../helpers";
import { connect } from "react-redux";
import Images from "../Images";
import { ReactSVG } from "react-svg";
import { updateFavoriteTeamForSportEvents } from "../../../redux/actions/sportEventsActions";


class EventDetails extends React.Component {
  state = {};
  nav = (item) => {
    const { history, setEvent, feedName, match } = this.props;
    setEvent(item);
    history.push(
      `/${feedName}/${match.params.feed}/${match.params.sport}/${
        item.sport.sportDisplayName
      }/event/${item.eventCategory.sportCategoryId}/${
        item.eventTournament.tournamentId
      }/${item.eventId}`
    );
  };
  checkImage = (teamId) => {
    this.setState({
      [teamId]: true,
    });
  };
    addToFavorate = (e, teamId, isFaviorite , teamType) => {
    e.stopPropagation();
    const { ManageMemeberFavorite, match, history ,updateFavoriteSportEvents , updateFavoriteTeamForSportEvents} = this.props;
    const favItemKey = `4-${teamId}-${match.params.sport}`;
    const memberFavorites =
      localStorage.getItem("memberFavorites") &&
      JSON.parse(localStorage.getItem("memberFavorites"));
    // if memberFavorites not exist then stop the function, else complete
    if (!memberFavorites) return;
    //
    const existingIndex = memberFavorites.findIndex(
      (item) => item.key === favItemKey
    );
    if (existingIndex > -1) {
      let element = memberFavorites.filter((item) => item.key == favItemKey);
      let data = {
        favoriteId: element[0].favoriteId,
        favoriteType: {
          favoriteTypeId: 4,
        },
        feedId: Number(match.params.feed),
        sportId: Number(match.params.sport),
        elementId: Number(teamId),
      };
      ManageMemeberFavorite(data);
    } else {
      let data = {
        favoriteType: {
          favoriteTypeId: 4,
        },
        feedId: Number(match.params.feed),
        sportId: Number(match.params.sport),
        elementId: Number(teamId),
      };
      ManageMemeberFavorite(data);
    }
    updateFavoriteTeamForSportEvents(teamId,!isFaviorite , teamType)

  };

  render() {
    const { event, showCategory , signedIn } = this.props;
    return (
      <div className="details" onClick={() => this.nav(event)}>
        {showCategory && (
          <div className="categoryDetails">
            <div className="category">{`${
              event.eventCategory.categoryDisplayName
            }, ${event.eventTournament.tournamentDisplayName}`}</div>
          </div>
        )}
        <div className="teams">
          <div className="bet-info">
            <span>
              <i
                className="fa-solid fa-star"
                style={{ color: "#334260", paddingRight: "5px" }}
              />
            </span>
            {signedIn && (
                <div className="teams-star-container">
                      <ReactSVG
                        className={`${
                          event.isHomeTeamFavorite
                            ? `favorite-icon-selected`
                            : ``
                        }`}
                        src={Images.LuckyNumberStar}
                        onClick={(e) =>
                          this.addToFavorate(
                            e,
                            event.eventHomeTeamId,
                            event.isHomeTeamFavorite,
                            'home'
                          )
                        }
                      />
                  </div>
            )}
            <div className="teams-position">{event.homeTeamRank}</div>
            {!this.state[event.eventHomeTeamId] && (
              <div style={{ paddingRight: "5px" }}>
                <img
                  src={`${AppConfig.teamsIconPath}${
                    event.eventHomeTeamId
                  }_s.webp`}
                  alt="leagues-icon"
                  height={"18px"}
                  width={"21px"}
                  // style={{marginLeft:"2px"}}

                  onError={() => this.checkImage(event.eventHomeTeamId)}
                />
              </div>
            )}
            {this.state[event.eventHomeTeamId] &&
            event.eventHomeTeamName.includes(" ") &&
            event.eventHomeTeamName.split(" ").length >= 2 ? (
              <div
                style={
                  event.eventHomeTeamColor &&
                  event.eventHomeTeamColor != "ffffff"
                    ? { backgroundColor: `#${event.eventHomeTeamColor}` }
                    : { backgroundColor: "#AEB4BF" }
                }
                className="events-alternative-image"
              >
                {" "}
                <span>{event.eventHomeTeamName.split(" ")[0][0]}</span>
                <span>{event.eventHomeTeamName.split(" ")[1][0]}</span>
              </div>
            ) : this.state[event.eventHomeTeamId] ? (
              <div
                style={
                  event.eventHomeTeamColor &&
                  event.eventHomeTeamColor != "ffffff"
                    ? { backgroundColor: `#${event.eventHomeTeamColor}` }
                    : { backgroundColor: "#AEB4BF" }
                }
                className="events-alternative-image"
              >
                {" "}
                <span>{event.eventHomeTeamName.split(" ")[0][0]}</span>
              </div>
            ) : (
              ""
            )}
            <TeamName name={event.eventHomeTeamName} />
          </div>
          <div className="bet-info">
            <span>
              <i
                className="fa-solid fa-star"
                style={{ color: "#334260", paddingRight: "5px" }}
              />
            </span>
            {signedIn && (
              <div className="teams-star-container">
                     <ReactSVG
                        className={`${
                          event.isAwayTeamFavorite
                            ? `favorite-icon-selected`
                            : ``
                        }`}
                        src={Images.LuckyNumberStar}
                        onClick={(e) =>
                          this.addToFavorate(
                            e,
                            event.eventAwayTeamId,
                            event.isAwayTeamFavorite,
                            'away'
                          )
                        }
                      />
               </div>
            )}
            <div className="teams-position">{event.awayTeamRank}</div>
            {!this.state[event.eventAwayTeamId] && (
              <div style={{ paddingRight: "5px" }}>
                {" "}
                <img
                  src={`${AppConfig.teamsIconPath}${
                    event.eventAwayTeamId
                  }_s.webp`}
                  alt="leagues-icon"
                  height={"18px"}
                  width={"21px"}
                  // style={{marginLeft:"2px"}}
                  onError={() => this.checkImage(event.eventAwayTeamId)}
                />
              </div>
            )}
            {/* { this.state[event.eventAwayTeamName] && event.eventAwayTeamName.split(' ').length>=2 &&  <div style={(event.eventAwayTeamColor ? {backgroundColor: `#${event.eventAwayTeamColor}`} : {backgroundColor:"#AEB4BF"})} className="events-alternative-image">

{" "}
<span>{event.eventAwayTeamName.split(' ')[0][0]}</span><span>{event.eventAwayTeamName.split(' ')[1][0]}</span>
</div>} */}
            {this.state[event.eventAwayTeamId] &&
            event.eventAwayTeamName.includes(" ") &&
            event.eventAwayTeamName.split(" ").length >= 2 ? (
              <div
                style={
                  event.eventAwayTeamColor &&
                  event.eventAwayTeamColor != "ffffff"
                    ? { backgroundColor: `#${event.eventAwayTeamColor}` }
                    : { backgroundColor: "#AEB4BF" }
                }
                className="events-alternative-image"
              >
                {" "}
                <span>{event.eventAwayTeamName.split(" ")[0][0]}</span>
                <span>{event.eventAwayTeamName.split(" ")[1][0]}</span>
              </div>
            ) : this.state[event.eventAwayTeamId] ? (
              <div
                style={
                  event.eventAwayTeamColor &&
                  event.eventAwayTeamColor != "ffffff"
                    ? { backgroundColor: `#${event.eventAwayTeamColor}` }
                    : { backgroundColor: "#AEB4BF" }
                }
                className="events-alternative-image"
              >
                {" "}
                <span>{event.eventAwayTeamName.split(" ")[0][0]}</span>
              </div>
            ) : (
              ""
            )}
            <TeamName name={event.eventAwayTeamName} />
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    signedIn: state.auth.signedIn,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateFavoriteTeamForSportEvents: (teamId, isFavorite , teamType) => {
      dispatch(updateFavoriteTeamForSportEvents(teamId, isFavorite , teamType));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventDetails);

